import { useCountInvalidFields } from 'components/common-form/hooks/invalid-fields/useCountInvalidFields';
import { useCountPatchedFields } from 'components/common-form/hooks/patched-fields/useCountPatchedFields';
import type { FC } from 'react';

import { FieldCountBadges } from './FieldCountBadges';

type BlockInvalidFieldsCountProps = {
  blockId: string;
  fieldIds: readonly string[];
  errorPrefix?: string;
};

export const BlockInvalidFieldsCount: FC<BlockInvalidFieldsCountProps> = ({ blockId, fieldIds, errorPrefix }) => {
  const invalid = useCountInvalidFields([fieldIds])[0];
  const modifiedCount = useCountPatchedFields([fieldIds])[0];
  return <FieldCountBadges id={blockId} value={invalid} modifiedCount={modifiedCount} errorPrefix={errorPrefix} />;
};
